import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { searchExtentionTimePerProjectPage } from '../../../redux/actions/contractExtendTimeReport'
import ExtentionTimePerProjectReportWidget from '../../../widgets/adminReport/extentionTimePerProjectReportWidgets/ExtentionTimePerProjectReportWidget'

export default function ExtentionTimePerProjectReport(props) {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await searchExtentionTimePerProjectPage({})
      console.log('_schema => ', _schema)
      setSchema(_schema)
      // setSchema(mockShema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    // console.log('load AllProjectSummaryReport')
    handleGetSchema()
  }, [])

  if (error) {
    return (
      <SidebarProposal isReport>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isReport>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }
  return (
    <SidebarProposal isReport>
      <ContentHeader header={schema?.header?.header} subHeader={schema?.subHeader} isNotCallApi />

      <ExtentionTimePerProjectReportWidget schema={schema} />
    </SidebarProposal>
  )
}

const mockShema = {
  header: 'รายงานการอนุมัติงบประมาณโครงการ',
  subHeader: '',
  form: {
    searchObject: {
      header: 'ค้นหาข้อมูล',
      reportName: 'รายงานการอนุมัติงบประมาณโครงการแยกตามเดือนของปีงบประมาณ',
      buttonText: {
        disabled: true,
        downloadButtonName: 'ดาวน์โหลด',
        previewButtonName: 'ตัวอย่างก่อนพิมพ์',
        cancelButtonName: 'ยกเลิก',
        searchButtonName: null,
      },
      pvDateStart: {
        name: 'pvDateStart',
        label: 'วันที่จ่ายเริ่มต้น : ',
        value: null,
        disabled: false,
      },
      pvDateEnd: {
        name: 'pvDateEnd',
        label: 'วันที่จ่ายสิ้นสุด : ',
        value: null,
        disabled: false,
      },
      budgetYear: {
        name: 'budgetYear',
        label: 'ปีงบประมาณ',
        value: 2566,
        options: [
          {
            label: '2565',
            value: 2565,
          },
          {
            label: '2566',
            value: 2566,
          },
          {
            label: '2567',
            value: 2567,
          },
        ],
      },
    },
  },
}
